<template>
	<table-paginator
		:data="accountPlans"
		@pagechange="$emit('pagechange', $event)"
	>
		<table class="customTable table ">
			<tr>
				<th>Descricao</th>
			</tr>
			<tbody>
				<tr v-for="row in accountPlans.data" :key="row.id">
					<td style="cursor:pointer">
						<div>
							<div @click="$emit('selectGroup', row.id)" class="hoverable">
								<span> # {{ row.code }} -</span>
								<strong>{{ row.description }}</strong>
							</div>

							<div
								class="pl-5 hoverable"
								v-for="i in row.account_plan"
								:key="i.id"
							>
								<div @click="$emit('selectPlan', i.id)">
									<small>{{ i.code }} </small>
									<small>{{ i.description }}</small>
								</div>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</table-paginator>
</template>

<script>
	import TablePaginator from "../../sections/TablePaginator";

	export default {
		components: {
			TablePaginator
		},

		props: {
			accountPlans: {}
		},

		computed: {},

		methods: {}
	};
</script>

<style>
.hoverable:hover {
  background-color: #cccbcbc9;
}
</style>
